// #region Common type
export const COMMON_TYPE = {
    ALL: 0,
    GAS: 1,
    EK: 2
} as const;

export type CommonType = (typeof COMMON_TYPE)[keyof typeof COMMON_TYPE];
// #endregion Common type

// #region Languages
export const LANGUAGES_SUPPORTED = {
    Japanese: 'ja',
    English: 'en'
    // Vietnamese: 'vi'
} as const;

export type LanguagesSupported = (typeof LANGUAGES_SUPPORTED)[keyof typeof LANGUAGES_SUPPORTED];

export const LANGUAGE_DEFAULT: LanguagesSupported = LANGUAGES_SUPPORTED.English;
// #endregion Languages

// role user
export const ROLE_USER = {
    SYSTEM_ADMIN: 1, // ADMIN GAS - EK
    BEST_BIKE_ADMIN: 2, // BB xe GAS - EK
    FRANCHISE_OWNER_PRM: 3, // FC-PRM xe GAS
    FRANCHISE_OWNER_STD: 4, // FC-STD xe GAS
    HOTEL_BIKE_OWNER: 5, // HO xe EK
    SHARE_BIKE_OWNER: 6, // SO xe GAS
    RENTAL_BIKE_OWNER_RD: 7, // RD xe GAS
    RENTAL_BIKE_OWNER_EK: 8 // EK xe EK
} as const;

export type RoleUserType = (typeof ROLE_USER)[keyof typeof ROLE_USER];

export const ROLE_OWNER = [ROLE_USER.FRANCHISE_OWNER_PRM, ROLE_USER.FRANCHISE_OWNER_STD, ROLE_USER.HOTEL_BIKE_OWNER, ROLE_USER.SHARE_BIKE_OWNER] as const;

export type RoleOwnerType = (typeof ROLE_OWNER)[keyof typeof ROLE_OWNER];

export const ROLE_ADMIN = [ROLE_USER.BEST_BIKE_ADMIN, ROLE_USER.SYSTEM_ADMIN];

export const ROLE_USER_CODE = {
    SYSTEM_ADMIN: 'ADMIN', // ADMIN GAS - EK
    BEST_BIKE_ADMIN: 'BB', // BB xe GAS - EK
    FRANCHISE_OWNER_PRM: 'FCPRM', // FC-PRM xe GAS
    FRANCHISE_OWNER_STD: 'FCSTD', // FC-STD xe GAS
    HOTEL_BIKE_OWNER: 'HO', // HO xe EK
    SHARE_BIKE_OWNER: 'SO', // SO xe GAS
    RENTAL_BIKE_OWNER_RD: 'RD', // RD xe GAS
    RENTAL_BIKE_OWNER_EK: 'EK' // EK xe EK
} as const;

export type RoleUserCodeType = (typeof ROLE_USER_CODE)[keyof typeof ROLE_USER_CODE];

export const GROUP_ROLE = {
    ADMIN: 1,
    OWNER: 2,
    USER: 3
};
// end role user

export const STATUS = {
    Inactive: 0,
    Active: 1
    // WaitConfirm: 2
} as const;

export type StatusType = (typeof STATUS)[keyof typeof STATUS];

// #region Approve
export const APPROVE_BIKE_STATUS = {
    WaittingApprove: 0,
    ResendApprove: 1,
    Approve: 2,
    Reject: 3
};

export type ApproveBikeStatusType = (typeof APPROVE_BIKE_STATUS)[keyof typeof APPROVE_BIKE_STATUS];

export const APPROVE_COUPON_STATUS = {
    WaittingApprove: 0,
    Approve: 1,
    Reject: 2
};

export type ApproveCouponStatusType = (typeof APPROVE_COUPON_STATUS)[keyof typeof APPROVE_COUPON_STATUS];
// #endregion Approve

export const GENDER = {
    Male: 0,
    Female: 1
} as const;

export type Gender = (typeof GENDER)[keyof typeof GENDER];

// ui
export const HEADER_FORMAT = {
    desktopGeneral: 'desktop-general',
    desktopShop: 'desktop-shop',
    mobile1: 'mobile-1',
    mobile2: 'mobile-2'
};

export type HeaderFormat = (typeof HEADER_FORMAT)[keyof typeof HEADER_FORMAT];

// #region Location

export const LOCATION_TYPE = {
    GAS: 1,
    EK: 2
} as const;

export type LocationType = (typeof LOCATION_TYPE)[keyof typeof LOCATION_TYPE];

// #endregion Location

// #region Coupon
export const COUPON_TYPE = {
    ONE_TIME_USE: 1,
    FOREVER_USE: 2
} as const;

export type CouponType = (typeof COUPON_TYPE)[keyof typeof COUPON_TYPE];
// #endregion Coupon

// #region Promotion
export const PROMOTION_TYPE = {
    PERCENTAGE: 1,
    MONEY: 2
} as const;

export type PromotionType = (typeof PROMOTION_TYPE)[keyof typeof PROMOTION_TYPE];
// #endregion Promotion

// #region Form mode
export const FORM_TYPE = {
    Create: 'create',
    Edit: 'edit',
    View: 'view'
} as const;

export type FormType = (typeof FORM_TYPE)[keyof typeof FORM_TYPE];
// #endregion Form mode

// #region Price Management

export const DURATION_TIME_TYPE = {
    TWENTY_FOUR_HOURS: 1,
    ONE_WEEK: 2,
    ONE_MONTH: 3,
    PLUS_ONE_DAY: 4
} as const;

export type DurationTimeType = (typeof DURATION_TIME_TYPE)[keyof typeof DURATION_TIME_TYPE];

// #endregion Price Management

// #region Answer Type

export const ANSWER_TYPE = {
    YES: true,
    NO: false
} as const;

export type AnswerType = (typeof ANSWER_TYPE)[keyof typeof ANSWER_TYPE];

// #endregion Answer Type

// #region Inquiry
export const PROGRESS_STATUS = {
    New: 0,
    InProgress: 1,
    Complete: 2
} as const;

export type ProgressStatusType = (typeof PROGRESS_STATUS)[keyof typeof PROGRESS_STATUS];
// #endregion Inquiry

// #region Option
export const OPTION_FORMAT = {
    Option: 1,
    Insurance: 2,
    DropOff: 4,
    ExtraMileage: 3
} as const;

export type OptionFormatType = (typeof OPTION_FORMAT)[keyof typeof OPTION_FORMAT];

export const OPTION_TYPE_VALUE = {
    YesNo: 2,
    Number: 1
} as const;

export type OptionTypeValueType = (typeof OPTION_TYPE_VALUE)[keyof typeof OPTION_TYPE_VALUE];
// #endregion Option

// #region Order
export const ORDER_STATUS = {
    Not_Paid: 0,
    Paid: 1,
    Available: 2,
    Return: 3,
    Cancel: 4,
    Operation: 5,
    Overdue: 6,
    Add_Not_Paid: 7
} as const;

export type OrderStatusType = (typeof ORDER_STATUS)[keyof typeof ORDER_STATUS];

export const REFUND_STATUS = {
    Refund: 1,
    Not_Refund: 0
};

export type RefundStatusType = (typeof REFUND_STATUS)[keyof typeof REFUND_STATUS];

export const ADDITIONAL_PAYMENT_TYPE = {
    ORDER: 0,
    TACHIGOKE: 1,
    OVER_MILEAGE: 2,
    DROP_OFF: 3,
    REPAIR_FEE: 4,
    OTHER: 5
};

export type AdditionalPaymentType = (typeof ADDITIONAL_PAYMENT_TYPE)[keyof typeof ADDITIONAL_PAYMENT_TYPE];

export const PAYMENT_STATUS = {
    NOT_PAID: 0,
    PAID_FAIL: 1,
    PAID_SUCCESS: 2,
    REFUNDED: 3,
    NOT_REFUNDED: 4,
    NO_NEED_REFUNDED: 5
};

export type PaymentStatusType = (typeof PAYMENT_STATUS)[keyof typeof PAYMENT_STATUS];

export const PAYMENT_HISTORY_STATUS = {
    NOT_PAID: 1,
    PAIDED: 2,
    REFUNDED: 3,
    NOT_REFUNDED: 4,
    NO_NEED_REFUNDED: 5
};

export type PaymentHistoryStatusType = (typeof PAYMENT_HISTORY_STATUS)[keyof typeof PAYMENT_HISTORY_STATUS];

export const PAYMENT_METHOD = {
    CREDIT_CARD: 1,
    PAYPAY: 2,
    VISUAL_TRANSFER: 3
};

export type PaymentMethodType = (typeof PAYMENT_METHOD)[keyof typeof PAYMENT_METHOD];

export const SALE_CLOSE_STATUS = {
    CLOSED: 1,
    NOT_CLOSED: 0
};
export type SaleCloseStatusType = (typeof SALE_CLOSE_STATUS)[keyof typeof SALE_CLOSE_STATUS];

export const PAYMENT_TYPE = {
    ORDER_CREATE: 0,
    UPDATE_ORDER: 1,
    OTHER: 2
};

export type PaymentType = (typeof PAYMENT_TYPE)[keyof typeof PAYMENT_TYPE];

export const INSURENCE_OPTION = {
    SUBSCRIBE: 1,
    NOT_SUBSCRIBE: 2
};

export type InsurenceOptionType = (typeof INSURENCE_OPTION)[keyof typeof INSURENCE_OPTION];

export const DROPOFF_OPTION = {
    ADD: 1,
    NOT_ADD: 2
};

export type DropOffOptionType = (typeof DROPOFF_OPTION)[keyof typeof DROPOFF_OPTION];

// #endregion Order

// #region Bike
export const BIKE_STATUS = {
    Available: 1,
    Completed: 2,
    Doing: 3,
    Returned: 4,
    LateReturn: 5
};

export type BikeStatusType = (typeof BIKE_STATUS)[keyof typeof BIKE_STATUS];

export const GEARBOX = {
    MT: 'MT',
    AT: 'AT'
};

export type GearboxType = (typeof GEARBOX)[keyof typeof GEARBOX];
// #endregion Bike

// #region News
export const NEWS_TYPE = {
    NEW_NEWS: 0,
    NOTIFICATIONS: 1,
    BIKE_INFO: 2,
    LOCATION_INFO: 3
};

export type NewsType = (typeof NEWS_TYPE)[keyof typeof NEWS_TYPE];
// #endregion Bike

// #region Driver license
export const DRIVER_LICENSE_STATUS_TYPE = {
    VALID: true,
    EXPIRED: false
};

export type DriverLicenseStatusType = (typeof DRIVER_LICENSE_STATUS_TYPE)[keyof typeof DRIVER_LICENSE_STATUS_TYPE];

export const LICENSE_TYPE_OPTION = {
    TRADITIONAL: 1, // 1. Bằng lái thông thường
    MY_NUMBER: 2 // 2. Bằng my number
} as const;

export type LicenseTypeOption = (typeof LICENSE_TYPE_OPTION)[keyof typeof LICENSE_TYPE_OPTION];
// #endregion Driver license

// #region Register
export const REGISTER_STATUS = {
    REGISTERED: 1,
    UNREGISTER: 0
} as const;

export type RegisterStatusType = (typeof REGISTER_STATUS)[keyof typeof REGISTER_STATUS];
// #endregion Register

// #region System setting
export const SYSTEM_SETTING_TYPE = {
    CANCEL_BOOKING: 1,
    PREPARATION_TIME: 2,
    OTHER: 3
} as const;

export type SystemSettingType = (typeof SYSTEM_SETTING_TYPE)[keyof typeof SYSTEM_SETTING_TYPE];
// #endregion Register

// #region Dashboard
export const DASHBOARD_LIST_TYPE = {
    NeedingArranged24AndOverdue: 1,
    LatePayment: 2,
    LateReturn: 3
};
export type DashboardListType = (typeof DASHBOARD_LIST_TYPE)[keyof typeof DASHBOARD_LIST_TYPE];

// #endregion Dashboard

// #region Honorific title
export const HONORIFIC_TITLE_TYPE = {
    COMPANY: '御中',
    PERSONAL: '様'
};
export type HonorificTitleType = (typeof HONORIFIC_TITLE_TYPE)[keyof typeof HONORIFIC_TITLE_TYPE];
// #endregion Honorific title

// #region Milestone of TimeLine
export const MILESTONE_PAYMENT = {
    ADDED_NOT_PAID: 1,
    ADDED_PAID: 2,
    NOTHING: 0
};
export type MileStonePaymentType = (typeof MILESTONE_PAYMENT)[keyof typeof MILESTONE_PAYMENT];
// #endregion

// #region Mode drive map
export const DRIVE_MODE_TYPE = {
    Transit: 'transit',
    Walking: 'walking'
};
export type DriveModeType = (typeof DRIVE_MODE_TYPE)[keyof typeof DRIVE_MODE_TYPE];
// #endregion Mode drive map

// #region Other Setting
export const OTHER_SETTING_TYPE = {
    MILEAGE_LIMIT: 1,
    DROP_OFF: 2
} as const;

export type OtherSettingType = (typeof OTHER_SETTING_TYPE)[keyof typeof OTHER_SETTING_TYPE];

export const ADDITIONAL_CHARGE_TYPE = {
    VARIABLE: 1,
    FIXED: 2,
    NONE: 0 // for drop-off
} as const;

export type AdditionalChargeType = (typeof ADDITIONAL_CHARGE_TYPE)[keyof typeof ADDITIONAL_CHARGE_TYPE];

export const GROUP_CAPACITY_TYPE = {
    NONE: 0, // for drop-off
    LQ_125CC: 1, // less or eq 125cc
    GQ_126CC: 2 // greater or eq 126cc
};

export type GroupCapacityType = (typeof GROUP_CAPACITY_TYPE)[keyof typeof GROUP_CAPACITY_TYPE];

export const CAPACITY_BIKE = {
    MOPED: 1,
    MOPED_2: 2,
    A250CC: 3,
    A400CC: 4,
    GT400CC: 5,
    PREMIUM: 6,
    TRIKE: 7
};

export type CapacityBikeType = (typeof CAPACITY_BIKE)[keyof typeof CAPACITY_BIKE];

// #endregion

// #region Download Invoice/Receipt
export const DOWNLOAD_TYPE = {
    INVOICE: 1,
    RECEIPT: 2
};
export type DownloadType = (typeof DOWNLOAD_TYPE)[keyof typeof DOWNLOAD_TYPE];
// #endregion
